import React, { useContext, useEffect, useRef, useState } from "react";
import "./SuccessComponent.css";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { set_image_upload_status } from "../../store/image_upload";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FileContext from "../../context/Context";
// import { ignore } from "antd/es/theme/useToken";
import CloseIcon from '@mui/icons-material/Close';
import ProgresBar from "../video-module-completion/ProgressBar"

const ProcessingHybrid= () => {
    const [isPopupOpen, setPopupOpen] = useState(false);
	const [ratingSucceeded,setRatingSucceded]=useState(false);
    const dispatch = useDispatch();
    const [rating, setRating] = useState(0);
	const [qualityCheck,setQualityCheck]=useState(false);
    const [reportGeneration,setReportGeneration]=useState(false);
	const {image_upload_status} = useSelector(state => state.imageUploadStore);
	const [imageUploadStatus, setImageUploadStatus] = useState(image_upload_status);
	
	const navigate = useNavigate();
	const {
		auditID,

	} = useSelector((state) => state.imagesStore);
	
  
	useEffect(() => {
	  // Update local state whenever Redux state changes
	  setImageUploadStatus(image_upload_status);
	}, [image_upload_status]);
	useEffect(() => {
		if (imageUploadStatus) {
		  recheckAuditImages();
		}
	  }, [imageUploadStatus]);

	// const [imageUploadStatusState,setImageUploadStatusState]=useState(image_upload_status);
	const { capturedInspectionImages,carView,odometerVideo } = useContext(FileContext);
	console.log(image_upload_status)

   
	
    // Number of images + 2 videos (carView & odometerVideo)


	const azure_image_file_name = (audit_id, image_name, file_name) => {
		return `${audit_id}_${image_name}_${file_name}`
	}
	const axiosInstance = axios.create({
		timeout: 30000,
	});


	const upload_images_data_db = async (formData, image_name, maxRetries = 3) => {
		let attempt = 0;
	  
		const tryUpload = async () => {
		  try {
			const response = await axiosInstance.post(
			  "/process_data/upload_process_store_individually",
			  formData,
			  {
				headers: {
				  "Content-Type": "multipart/form-data",
				},
			  }
			);
			
			if (response.status === 200) {
			  const res = {
				image_name: image_name,
				status: 1,
				type: "sql_upload_status",
			  };
			  dispatch(set_image_upload_status(res));
		// 	  setTasksCompleted(prev => prev + 1);
        // handleProgressUpdate();
			//   setImageUploadStatusState((prevState) => {
			// 	const { image_name, status, type } = res;
				
			// 	// Check if image_name exists in the current state
			// 	if (prevState.image_upload_status[image_name]) {
			// 		// Create a copy of the previous state
			// 		const updatedState = { ...prevState };
					
			// 		// Update the specific status for the image
			// 		updatedState.image_upload_status[image_name][type] = status;
					
			// 		console.log(image_name, status, type, "Updated successfully");
			// 		return updatedState;  // Return the updated state
			// 	} else {
			// 		console.warn(`Image type ${image_name} does not exist in the state.`);
			// 		return prevState;  // Return the previous state if the image doesn't exist
			// 	}
			// });
			
			  console.log("Successful sql upload", response.data);
			  return res; // Successful upload
			}
		  } catch (error) {
			attempt++;
			if (attempt < maxRetries && (error.code === "ECONNABORTED" || (error.response && error.response.status >= 500))) {
			  console.log(`Attempt ${attempt} failed. Retrying in ${Math.pow(2, attempt)} seconds...`);
			  await new Promise((resolve) => setTimeout(resolve, Math.pow(2, attempt) * 1000));
			  return tryUpload(); // Retry the upload
			} else {
			  console.error("Max retries reached or non-retryable error:", error);
			  return false; // Failed after retries
			}
		  }
		};
	  
		return tryUpload();
	  };
	  
	
	const uploadCachedImageToAzure = async (fileName, image_name) => {
		try {
			const cache = await caches.open('image-cache');

			const keys = await cache.keys();
      
			// Filter keys that include the substring like this 'BCVX05104118_RC_captured_image.jpeg'
			const matchingKeys = keys.filter(request => request.url.includes(`${fileName}`));
			
			if (matchingKeys.length === 0) {
			  console.log('No matching cached image found');
			  return;
			}

			
			const cachedResponse = await cache.match(matchingKeys[0]);
		
			if (!cachedResponse) {
				throw new Error(`No cached image found with the key: ${fileName}`);
			}
			const imageBuffer = await cachedResponse.arrayBuffer();
			const blob = new Blob([imageBuffer], { type: 'image/png' });

			const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditImages/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

			const headers = {
				'Content-Type': 'image/png',
				'x-ms-blob-type': 'BlockBlob'
			};
			await axios.put(url, blob, { headers })
				.then(response => {
					if (response.status === 201) {
						const res = {
							image_name: image_name,
							status: 1,
							type: "azure_img_upload_status"
						}
						dispatch(set_image_upload_status(res))
						
				  
						// setImageUploadStatusState((prevState) => {
						// 	const { image_name, status, type } = res;
							
						// 	// Check if image_name exists in the current state
						// 	if (prevState.image_upload_status[image_name]) {
						// 		// Create a copy of the previous state
						// 		const updatedState = { ...prevState };
								
						// 		// Update the specific status for the image
						// 		updatedState.image_upload_status[image_name][type] = status;
								
						// 		console.log(image_name, status, type, "Updated successfully");
						// 		return updatedState;  // Return the updated state
						// 	} else {
						// 		console.warn(`Image type ${image_name} does not exist in the state.`);
						// 		return prevState;  // Return the previous state if the image doesn't exist
						// 	}
						// });
					}
					console.log('File uploaded successfully. Status Code:', response.status);
				})
				.catch(error => {
					console.error('Error uploading file:', error);
				});
		} catch (error) {
			console.error('Error retrieving or uploading cached image:', error);
		}
	};
   
    const handleButtonClick = () => {
        setPopupOpen(true);
    };

    const handleClosePopup = () => {
        setPopupOpen(false);
    };

    const handleStarClick = (star) => {
        setRating(star)
		
    };
	const handleSubmit =()=>{
		setRatingSucceded(true)
	 
	}
		
	const upload_video_to_azure = async (fileName, videoBlob) => {
        const videoType = videoBlob.type || 'video/mp4';

        const headers = {
            'Content-Type': videoType,
            'x-ms-blob-type': 'BlockBlob',
        };

        const url = `https://caisdatahouse.blob.core.windows.net/insurance-inspection/auditVideos/${fileName}?sv=2022-11-02&ss=b&srt=sco&sp=rwdlacyx&se=2030-12-24T21:24:33Z&st=2023-12-24T13:24:33Z&spr=https&sig=Ytog9LRRNwVpscHMH5q3Q8F7v6U2Te5F6oU8%2F1WArio%3D`;

        await axios.put(url, videoBlob, {
            headers,
            onUploadProgress: (progressEvent) => {
                const total = progressEvent.total;
                const current = progressEvent.loaded;
                const percentCompleted = Math.round((current * 100) / total);
                // setUploadProgress(percentCompleted); // Update the progress state
                console.log(`Upload progress: ${percentCompleted}%`);
            }
        })
        .then(response => {
            if (response.status === 201) {
                console.log('Video uploaded successfully:', response.status);
				
            }
        })
        .catch(error => {
            console.error('Error uploading video:', error);
        });
    };
    const check = `${process.env.PUBLIC_URL}/custom-icons/timer.png`;
    const timer = `${process.env.PUBLIC_URL}/inspection-images/check-icon.png`;
    const star = `${process.env.PUBLIC_URL}/inspection-images/star.png`;
    const step1_pink = `${process.env.PUBLIC_URL}/custom-icons/step1-pink.svg`;;
    const step2_grey = `${process.env.PUBLIC_URL}/custom-icons/step2-grey.svg`;
    const step3_grey = `${process.env.PUBLIC_URL}/custom-icons/step3-grey.png`;
    const step2_pink = `${process.env.PUBLIC_URL}/custom-icons/step2-pink.png`;
    const step3_pink = `${process.env.PUBLIC_URL}/custom-icons/step3-pink.png`;
	const close = `${process.env.PUBLIC_URL}/custom-icons/close.png`;
    const success = `${process.env.PUBLIC_URL}/inspection-images/success-background.png`;
    const starEmpty = `${process.env.PUBLIC_URL}/inspection-images/image.png`;
    const starFilled = `${process.env.PUBLIC_URL}/inspection-images/star-filled.png`;


	const hasRunRef = useRef(false);

	useEffect(() => {
	  const funcCall = async () => {
		const odometer_video_file_name = `${auditID}_rpm_meter_video.mp4`;
		const car_view_video_file_name = `${auditID}_360_video.mp4`;
		await upload_video_to_azure(odometer_video_file_name, odometerVideo[0]);
		await upload_video_to_azure(car_view_video_file_name, carView[0]);
		await handleRetry();
	  };
  
	  if (!hasRunRef.current) {
		funcCall();
		hasRunRef.current = true;
	  }
	}, []);
	
  
  const recheckAuditImages = async (flag) => {
	
	for (let image_name_key in imageUploadStatus) {
	  if (
		imageUploadStatus[image_name_key].azure_img_upload_status === 0 ||
		imageUploadStatus[image_name_key].sql_upload_status === 0
	  ) {
		console.log("false",flag,image_name_key,imageUploadStatus[image_name_key].azure_img_upload_status,imageUploadStatus[image_name_key].sql_upload_status);
		return false;
	  }
	}
	await handleProceed();
	console.log("rechecked called!")
	return true;
  };
  
  const handleProceed = async () => {
	const result2 = await axios.post("/create_audit/update_token", {
	  audit: auditID,
	  processed: 1,
	  status:"processing"
	});
	setQualityCheck(true)
	console.log(result2);
  };
  

   
const handleRetry = async () => {
	let lastKey = null;
	const retryPromises = []; // Store all promises to ensure all operations are complete

	// Iterate over the keys using for...in
	for (let image_name_key in image_upload_status) {
		const imageDetail = capturedInspectionImages.find(
			(image) => image.name === image_name_key
		);

		if (
			image_upload_status[image_name_key].azure_img_upload_status === 0 ||
			image_upload_status[image_name_key].sql_upload_status === 0
		) {
			const fileName = azure_image_file_name(
				auditID,
				imageDetail.name,
				imageDetail.file.name
			);

			if (auditID) {
				const retryTask = (async () => {
					const cache = await caches.open("image-cache");
					const keys = await cache.keys();
					const matchingKeys = keys.filter((request) =>
						request.url.includes(`${fileName}-meta`)
					);

					if (matchingKeys.length === 0) {
						console.log("No matching cached image found");
						return; // Skip to the next key
					}

					const cachedResponse = await cache.match(matchingKeys[0]);
					if (cachedResponse) {
						const cachedData = await cachedResponse.json();
						const formData = new FormData();

						if (image_upload_status[image_name_key].azure_img_upload_status === 0) {
							await uploadCachedImageToAzure(fileName, cachedData.name);
						}

						if (image_upload_status[image_name_key].sql_upload_status === 0) {
							formData.append("clickedTime", cachedData.clicked_time);
							formData.append("name", cachedData.name);
							formData.append("id", cachedData.type);
							formData.append("auditID", cachedData.audit_id);
							formData.append("latitude", cachedData.latitude);
							formData.append("longitude", cachedData.longitude);
							formData.append("azure_image_name", fileName);
							await upload_images_data_db(formData, cachedData.name);
						}
					} else {
						console.log("No cached data found");
					}
				})();
				
				// Push the task into the array of promises
				retryPromises.push(retryTask);
			}
		}

		// Track the last processed key
		lastKey = image_name_key;
	}

	// Wait for all retryPromises to complete
	await Promise.all(retryPromises);

	// Once all processing is complete, return 1
	// await recheckAuditImages(lastKey)
	
	return 1;
};
  
    return (
        <>
            <div className="success-container">
                <div className="illustration-section">
                    <img src={success} alt="Success Illustration" />
                </div>
                <div className="content-section">
                    <div className="check-icon">
                        <img src={check} alt="Check Icon" />
                    </div>
                    <h2>Processing</h2>
                    <p>We are processing the inspection. Keep the window open.</p>
					<ol className="steps-list">
					<li className="step">
                <span className="step-number-audit">
                    <img src={step1_pink} alt="Step 1" />
                </span>
                Quality Check
                {/* <span className="vertical-line"></span>
                <br />
                <div className="progress-container">
                    <ProgresBar percentage={progress} />
                </div> */}
                {!qualityCheck && <span className="upload-status">Uploading</span>}
            </li>
  <li className="step">
    <span className="step-number-audit">
      {qualityCheck ? (
        <img src={step2_pink} alt="Step 2" />
      ) : (
        <img src={step2_grey} alt="Step 2" />
      )}
    </span>
	
    Report Generation
    {/* {qualityCheck && !reportGeneration && (
      <span>
        <CircularProgress
          sx={{ color: "#ff0088", width: "20px !important", height: "20px !important" }}
        />
      </span>
    )} */}
   <span className="vertical-line2"></span>
  </li>
  <li className="step disabled-step">
    <span className="step-number-audit">
      {reportGeneration ? (
        <img src={step3_pink} alt="Step 3" />
      ) : (
        <img src={step3_grey} alt="Step 3" />
      )}
    </span>
    Report Submission
  </li>
</ol>

                </div>
                <button className="rate-experience-btn" onClick={handleButtonClick}>
                    <img src={star} alt="Star Icon" /> RATE EXPERIENCE
                </button>
            </div>

            {isPopupOpen && (
                <div className="popup-overlay">
                    <div className="popup-content">
                        <div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>
						
                        <div className="rating-heading"><h4>How was your experience?</h4></div>
						<p>Please share with us your feedback:</p>
                        <div className="rating-stars">
                            {[1, 2, 3, 4, 5].map(starIndex => (
                                <img
                                    key={starIndex}
                                    src={starIndex <= rating ? starFilled : starEmpty}
                                    alt={`Star ${starIndex}`}
                                    className="star-icon"
                                    onClick={() => handleStarClick(starIndex)}
                                />
                            ))}
                        </div>
						<button
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.2rem",
            border: rating!=0 ? "1.5px solid #FF0083" : "1.5px solid #0000003D",
            padding: "0rem 1rem",
            backgroundColor: rating!=0 ? "#FF0083" : "#dcdcdc",
            color: rating!=0  ? "#ffffff" : "#0000003D", 
            borderRadius: "3px",
            opacity: "0.9",
            width:"100%",
			marginTop:"0.5rem"
		
          }}
		  disabled={rating!=0?false: true}
		  onClick={handleSubmit}
        >
          <p
            style={{
              fontSize: "0.9rem",
              fontFamily: "'Montserrat', sans-serif",
            //   color: "#FF0083",
			color: rating!=0  ? "#ffffff" : "#0000003D", 
              padding: "0.5rem",
              cursor: "pointer"
            }}
            
          >
			 
            Submit
          </p>
        </button>
						
                        {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
                    </div>
                </div>
            )}
			{isPopupOpen && ratingSucceeded && (
                <div className="popup-overlay">
                    <div className="popup-content-after-rating">
                        <div className="close-popup" onClick={handleClosePopup}><CloseIcon /></div>
						
                        <div className="rating-heading-completion"><h4>Thank you for sharing 
						your feedback</h4></div>
						<p style={{textAlign:"center"}}>We appreciate your input and will use it to improve our services.</p>
                       
						
                        {/* <p>Your rating: {rating} {rating > 1 ? 'stars' : 'star'}</p> */}
                    </div>
                </div>
            )}
        </>
    );
};

export default ProcessingHybrid